import { render, staticRenderFns } from "./AscPowerBiIcon.vue?vue&type=template&id=4368c87e&scoped=true&"
import script from "./AscPowerBiIcon.vue?vue&type=script&lang=js&"
export * from "./AscPowerBiIcon.vue?vue&type=script&lang=js&"
import style0 from "./AscPowerBiIcon.vue?vue&type=style&index=0&id=4368c87e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4368c87e",
  null
  
)

export default component.exports